import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/lsa'

Styxie.Initializers.LsaAgents = {
  index: async(props) => {
    const { default: AgentsIndex } = await import('@/vue_widgets/lsa/agents/index.vue')
    createVueApp(AgentsIndex, { props, sidebar })
  }
}
